// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { AuthProvider } from "@asgardeo/auth-react";
import { AUTH_CONFIG } from "./Config";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import GlobalStyles from "./components/GlobalStyles";
import HomePage from "./pages/HomePage";
import NotFound from "./pages/NotFound";
import theme from "./theme";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider config={AUTH_CONFIG}>
        <BrowserRouter>
          <Switch>
            <Route path={"/"} render={({ match, location, history }) => {
              return (
                <HomePage page={location.pathname} />
              )
            }} />
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
